import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
    settheInternalSubQuestionActions,
    setthereassignandAssignRejectDataActions,
    settheInternalDepartmentsctions,
    settheCreateInternalTickets,
    settheTicketSuccesspopuos,
    settheTicketViewIds,
    getTheUDSQuestionsData,
    settheReassignTicketpopups
} from "../../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { toast } from "react-toastify";
import { PresentUrl, stateCretae } from "../../../../text/apidata";
import { store } from "../../../../Redux/Store";
import axios from "axios";
import TicketCreation from "../../../../Assets/AppComponent/OBJECT.svg"
import Userim from "../../../../Assets/AppComponent/Layer_1 (2).svg";
import CloseIcons from "../../../../Assets/AppComponent/Group 442 (1).svg";

import galleryImg from "../../../../Assets/AppComponent/Union (25).svg";
import { useNavigate } from "react-router-dom";
import thumbsup from "../../../../Assets/AppComponent/plastic-hand-with-thumb-up 1 (1).svg";
import ticketimg from "../../../../Assets/AppComponent/Union (17).svg";
import closepopup from "../../../../Assets/AppComponent/Group 442 (1).svg";
import galleyimg from "../../../../Assets/AppComponent/Vector (20).svg"

import PDFIMAGE from "../../../../Assets/AppComponent/Rectangle.png"
import excelimg from "../../../../Assets/AppComponent/download.png"
import gallimages from "../../../../Assets/AppComponent/Vector (20).svg"
import useDebouncedEffect from 'use-debounced-effect';


const TicketAssigns = (props) => {
    const { show, setShow, getthesearch, currentPage,

        from_date,
        to_date,
        status,
        priority,
        stateids,
        region,
        zone,
        client,

    } = props;
    const state = useSelector((state) => state);

    const initialStateSearch = {
        categorySearch: "",
        usersearh: "",
        departmentseach: "",
        stateSearch: ''
    };
    const [SearchedVal, setSearched] = useState(initialStateSearch);

    const initialDebouanceSearch = {
        categorySearch: "",
        usersearh: "",
        departmentseach: "",
        stateSearch: '',
    };
    
    const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);
    const createnewuser = {
        remarks: "",
        priority: "",
        client_subcategory: true,
        internal_category_id: "",
        department_id: "",
        document: [],
        category: ""

    };

    const [data, setData] = useState(createnewuser);
    const [Priorityvalues, setPriorityvalues] = useState([])
    const [departmentValue, setDepartmentvalues] = useState([]);
    const [departmentoptions, setdepartmentoptions] = useState([])


    const dispatch = useDispatch();

    const priorityoptions = [
        {
            value: "0",
            label: "Low"
        },
        {
            value: "1",
            label: "Medium"

        },
        {
            value: "2",
            label: "High"

        }
    ];

    const capitalizeFirstLetter = (Letter) => {
        return Letter.charAt(0).toUpperCase() + Letter.slice(1);
    };

    const [Categorydata, setcategoryData] = useState([]);
    const [categoryvalue, setcategoryvalues] = useState([]);

    const [PresentUrls, setPresentUrls] = useState([]);
    const [presenturlInUrl, seturlandfile] = useState([]);
    const [croppedFileState, setcroppedFilestatet] = useState([]);
    const [documentnotuploads, setdosumentuploads] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const [isDragging, setIsDragging] = useState(false);

    const handleDragEnter = () => setIsDragging(true);
    const handleDragLeave = () => setIsDragging(false);

    const [thankcontent, setthankcontent] = useState(true);
    const [thanksContent, setThankthanksContent] = useState(true);
    const [categoryvaluese, setCategoryvaluesdep] = useState([])
    const [categoryption, setcategoryOptions] = useState([])

    const Navigate = useNavigate()


    useDebouncedEffect(
        () => {
            if (setSearchDebounance) {
                setSearched({
                    ...SearchedVal,
                    categorySearch: SearchDebounance.categorySearch,
                    departmentseach: SearchDebounance.departmentseach,
                    stateSearch: SearchDebounance.stateSearch,
                    usersearh:SearchDebounance.usersearh,
                });
    
            }
        },
        500,
        [SearchDebounance]
    );
    
    

    const HandleCategoryMuliti = (e) => {
        if (e != null) {
            setcategoryvalues(e);

            setData({
                ...data,
                internal_category_id: e.value
            })
        }
    }

    const handletheprioritychanges = (e) => {
        setPriorityvalues(e)
        setData({
            ...data,
            priority: e.value
        })
    }

    const HandletheDepartmentvalues = (e) => {
        setDepartmentvalues(e)
        setCategoryvaluesdep([])
        setcategoryvalues([])

        setData({
            ...data,
            department_id: e.value,
            category: "",
            internal_category_id: ""


        })
    }
    useEffect(() => {
        const payload = {
            search: SearchedVal.categorySearch,
            page_size: 20,
            page: 1,
            category: data.category,
        };
        dispatch(settheInternalSubQuestionActions(payload));
    }, [SearchedVal.categorySearch, data.category]);

    useEffect(() => {
        const payload = {
            search: SearchedVal.departmentseach,
            page_size: 20,
            page: 1,
        };
        dispatch(settheInternalDepartmentsctions(payload));
    }, [SearchedVal.departmentseach]);
    const handleInputcategorySearc = (e) => {
        setSearchDebounance({
            ...SearchDebounance,
                  stateSearch: e
        })
    }



    useEffect(() => {
        if (state.InternalSubDepartmentsDatas.internalDepartmentDatas !== undefined) {
            let ObjectArrayFormager = [];
            state.InternalSubDepartmentsDatas.internalDepartmentDatas.forEach((element) => {
                ObjectArrayFormager.push({
                    value: element.id,
                    label: element.department_name,
                });

            });


            setdepartmentoptions(ObjectArrayFormager);
        }
    }, [state.InternalSubDepartmentsDatas.internalDepartmentDatas, SearchedVal.departmentseach]);



    useEffect(() => {
        if (data.department_id != "" && data.category != "") {

            if (state.InternalSubQuetionsDatas.internalQuestionsDatas !== undefined) {
                let ObjectArrayFormager = [];
                state.InternalSubQuetionsDatas.internalQuestionsDatas.forEach((element) => {
                    ObjectArrayFormager.push({
                        value: element.id,
                        label: element.name,
                    });

                });


                setcategoryData(ObjectArrayFormager);
            }
        }
    }, [state.InternalSubQuetionsDatas.internalQuestionsDatas, SearchedVal.categorySearch, data.category]);



    const handleInputcategory = (e) => {
        setSearchDebounance({
            ...SearchDebounance,
                  categorySearch: e
        })
    }
    const handleInputDepartment = (e) => {
        setSearchDebounance({
            ...SearchDebounance,
                  departmentseach: e
        })
    }

    useEffect(() => {
        if (uploadedFiles.length == 0) {
            setdosumentuploads(false);
        }
    }, [uploadedFiles]);




    const handleDrop = useCallback((event) => {
        event.preventDefault();

        const droppedFiles = Array.from(event.dataTransfer.files);
        const validFiles = droppedFiles.filter((file) => {
            const isPhotoOrVideo =
                file.type.startsWith("image/") || file.type.startsWith("video/");
            const isExcel =
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "application/vnd.ms-excel";
            const isPdf = file.type === "application/pdf";
            const isEmail = file.type === "message/rfc822"; // MIME type for email files
            const isUnder5MB = file.size <= 25 * 1024 * 1024; // 5 MB size limit

            // return (isPhotoOrVideo || isExcel || isPdf || isEmail) && isUnder5MB;
            return isUnder5MB;
        });

        const invalidFiles = droppedFiles.filter((file) => {
            const isPhotoOrVideo =
                file.type.startsWith("image/") || file.type.startsWith("video/");
            const isExcel =
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "application/vnd.ms-excel";
            const isPdf = file.type === "application/pdf";
            const isEmail = file.type === "message/rfc822";
            const isUnder5MB = file.size <= 25 * 1024 * 1024;

            // Check if the file fails size validation
            if (!isUnder5MB) {
                toast.error(`${file.name} exceeds the 25 MB size limit.`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }

            // Check if the file fails type validation
            // if (!(isPhotoOrVideo || isExcel || isPdf || isEmail)) {
            //     toast.error(`${file.name} is not a valid file type.`, {
            //         position: "top-right",
            //         autoClose: 5000,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: true,
            //     });
            // }

            // return !(isPhotoOrVideo || isExcel || isPdf || isEmail) || !isUnder5MB;
            return !isUnder5MB;

        });
        // Exit if no valid files
        if (validFiles.length === 0) {
            return;
        }

        validFiles.forEach((file) => {
            const reader = new FileReader();

            reader.onload = () => {
                const base64Url = reader.result;

                setUploadedFiles((prevFiles) => [...prevFiles, base64Url]);
            };

            reader.readAsDataURL(file);
        });

        if (validFiles.length > 0) {
            const newFiles = validFiles.map((file) => URL.createObjectURL(file));


            setUploadedFiles((prev) => [...prev, ...newFiles]);
            setdosumentuploads(true);
            setcroppedFilestatet((prev) => [...prev, ...validFiles]);


            const generateRandomNumber = () => {
                return Math.floor(Math.random() * 100000);
            };

            const createPresentData = (file) => {
                const randomNumber = generateRandomNumber();
                const formattedFilename = `ticketing_system/internal_ticket/${file.name}`; // Adjust the filename as needed
                return {
                    multiple_files: [
                        {
                            filename: formattedFilename,
                            file_type: file.type,
                        },
                    ],
                };
            };

            validFiles.forEach((fileOfsend) => {
                const presentData = createPresentData(fileOfsend);

                axios({
                    url: PresentUrl,
                    method: 'post',
                    data: presentData,
                    headers: {
                        Authorization:
                            "Bearer " + store.getState().users.UserData.session.token,
                    },
                })
                    .then((response) => {
                        // console.log('Files uploaded successfully:', response.data);
                        const uploadedFiles = response.data.data;

                        const newUrls = uploadedFiles.map(file => ({
                            url: file,
                            type: fileOfsend.type,
                            putfiles: fileOfsend

                        }));
                        setPresentUrls((prevUrls) => [...prevUrls, ...newUrls]);

                        const SendUrl = String(response.data.data).split("?")[0]; // Extract URL up to '?'

                        if (SendUrl) {
                            seturlandfile((prevUrls) => [...prevUrls, SendUrl]); // Add the URL to the array
                        }


                    }).catch((error) => {
                        console.error('Error uploading files:', error);
                    });
            });




        }
    }, []);



    const HandletheCatgoryListed = (e) => {
        setCategoryvaluesdep(e);
        setcategoryvalues([])
        setData({
            ...data,
            category: e.value,
            internal_category_id: ""

        })
    }


    useEffect(() => {
        const payload = {
            search: SearchedVal.stateSearch,
            page_size: 20,
            page: 1,
            department_id: data.department_id,
        };
        dispatch(getTheUDSQuestionsData(payload));
    }, [SearchedVal.stateSearch, data.department_id]);


    useEffect(() => {
        if (data.department_id != "") {
            if (state.UDSQuetionsDatas.UDSCateQuestionsDatas != undefined) {
                let ObjectArrayFormager = [];
                state.UDSQuetionsDatas.UDSCateQuestionsDatas != undefined && state.UDSQuetionsDatas.UDSCateQuestionsDatas != null && state.UDSQuetionsDatas.UDSCateQuestionsDatas.forEach((element) => {
                    ObjectArrayFormager.push({
                        value: element.id,
                        label: element.name,
                    });

                });


                setcategoryOptions(ObjectArrayFormager);
            }
        }
    }, [state.UDSQuetionsDatas.UDSCateQuestionsDatas, SearchedVal.stateSearch, data.department_id]);


    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);

        const validFiles = files.filter((file) => {
            const isPhotoOrVideo =
                file.type.startsWith("image/") || file.type.startsWith("video/");
            const isExcel =
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "application/vnd.ms-excel";
            const isPdf = file.type === "application/pdf";
            const isEmail = file.type === "message/rfc822"; // MIME type for email files
            const isUnder5MB = file.size <= 25 * 1024 * 1024; // 5 MB size limit

            return isUnder5MB;
        });

        const invalidFiles = files.filter((file) => {
            const isPhotoOrVideo =
                file.type.startsWith("image/") || file.type.startsWith("video/");
            const isExcel =
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "application/vnd.ms-excel";
            const isPdf = file.type === "application/pdf";
            const isEmail = file.type === "message/rfc822";
            const isUnder5MB = file.size <= 25 * 1024 * 1024;

            // Check if the file fails size validation
            if (!isUnder5MB) {
                toast.error(`${file.name} exceeds the 25 MB size limit.`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }



            // Check if the file fails type validation
            // if (!(isPhotoOrVideo || isExcel || isPdf || isEmail)) {
            //     toast.error(`${file.name} is not a valid file type.`, {
            //         position: "top-right",
            //         autoClose: 5000,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: true,
            //     });
            // }

            // if (!isUnder5MB) {
            //     toast.error(`${file.name} exceeds the 25 MB size limit.`, {
            //         position: "top-right",
            //         autoClose: 5000,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: true,
            //     });
            // }


            // return (isPhotoOrVideo || isExcel || isPdf || isEmail) && isUnder5MB;
            return !isUnder5MB;
        });



        // return !(isPhotoOrVideo || isExcel || isPdf || isEmail) || !isUnder5MB;
        // });
        // Exit if no valid files
        if (validFiles.length === 0) {
            return;
        }

        const newFiles = validFiles.map((file) => URL.createObjectURL(file));
        setUploadedFiles((prev) => [...prev, ...newFiles]);
        setdosumentuploads(true);
        setcroppedFilestatet((prev) => [...prev, ...validFiles]);

        const generateRandomNumber = () => {
            return Math.floor(Math.random() * 100000);
        };
        const createPresentData = (file) => {
            const randomNumber = generateRandomNumber();
            const formattedFilename = `ticketing_system/internal_ticket/${file.name}`; // Adjust the filename as needed
            return {
                multiple_files: [
                    {
                        filename: formattedFilename,
                        file_type: file.type,
                    },
                ],
            };
        };


        validFiles.forEach((fileOfsend) => {
            const presentData = createPresentData(fileOfsend);

            axios({
                url: PresentUrl,
                method: 'post',
                data: presentData,
                headers: {
                    Authorization:
                        "Bearer " + store.getState().users.UserData.session.token,
                },
            })
                .then((response) => {
                    // console.log('Files uploaded successfully:', response.data);
                    const uploadedFiles = response.data.data;

                    const newUrls = uploadedFiles.map(file => ({
                        url: file,
                        type: fileOfsend.type,
                        putfiles: fileOfsend

                    }));
                    setPresentUrls((prevUrls) => [...prevUrls, ...newUrls]);

                    const SendUrl = String(response.data.data).split("?")[0]; // Extract URL up to '?'

                    if (SendUrl) {
                        seturlandfile((prevUrls) => [...prevUrls, SendUrl]); // Add the URL to the array
                    }


                }).catch((error) => {
                    console.error('Error uploading files:', error);
                });
        });



    };

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const removeFile = (index) => {
        setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
        setcroppedFilestatet((prev) => prev.filter((_, i) => i !== index));
        setPresentUrls((prev) => prev.filter((_, i) => i !== index));
        seturlandfile((prev) => prev.filter((_, i) => i !== index));
    };

    console.log(state.NeededdatasListed.findthReassings, "NeededdatasListed.findthReassings");
    console.log(state.StateManagementOverallCall.ReassignTicketIds, "StateManagementOverallCall.ReassignTicketIds", state.StateManagementOverallCall.TicketIDS);

    // console.log(state.StateManagementOverallCall.AssignandReassign, "dioasudiuasd oasiduasid ", state.NeededdatasListed.TicketSucssesPopup);
    const HandleClick = (e) => {

        const fetchUploadFiles = async () => {
            await Promise.all(PresentUrls.map(async (item, index) => {
                try {
                    if (item != undefined && item != null) {

                        const response = await fetch(item.url, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': item.type,
                                "x-amz-acl": "public-read"
                            },
                            body: item.putfiles,
                        });

                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }

                        if (PresentUrls.length == index + 1) {
                            const payload = {
                                data: {
                                    remarks: data.remarks,
                                    priority: data.priority,
                                    client_subcategory: true,
                                    internal_category_id: data.internal_category_id,
                                    department_id: data.department_id,
                                    documents: presenturlInUrl,
                                    ticket_assign_mode: state.StateManagementOverallCall.AssignandReassign == 1 ? "assign" : "reassign",
                                },
                                // getpayloads: {
                                //     search: "",
                                //     currentPage: 1,
                                //     page_size: 20,
                                // }
                                EditId: state.StateManagementOverallCall.AssignandReassign == 1 ? state.StateManagementOverallCall.TicketIDS : state.StateManagementOverallCall.ReassignTicketIds,
                                ticket_assign_mode: state.StateManagementOverallCall.AssignandReassign == 1 ? "Assign" : "Reassign",
                                // Funcations: () => {
                                //     Navigate("/ticketviews")

                                //   },
                                //   Funcationsreassign: () => {
                                //     Navigate("/internal_ticketview")

                                //   },
                                Funcations: () => {
                                    if (state.StateManagementOverallCall.AssignandReassign == 1) {
                                        Navigate("/ticketviews")
                                    }
                                    else {
                                        // Navigate("/internal_ticketview")



                                        if (state.NeededdatasListed.findthReassings == 3) {
                                            Navigate("/sub_ticker")
                                        }
                                        else if (state.NeededdatasListed.findthReassings == 9) {
                                            // Navigate("/internal_ticketview")
                                            Navigate("/ticketdashboard")


                                        }
                                        else {
                                            Navigate("/sub_ticker")


                                        }




                                    }
                                },
                            }
                            dispatch(setthereassignandAssignRejectDataActions(payload))
                            // dispatch(settheCreateInternalTickets(payload
                            //     // ,state.NeededdatasListed.RoutesDefinedof == 0 ?Navigate("/internaldashboard") : Navigate("/internalTicket")
                            // ))
                        }

                    }
                } catch (error) {
                    console.error('Error uploading files:', error);
                }
            }));
        };


        if (data.department_id != "" &&
            data.internal_category_id != "" &&
            data.priority != ""
        ) {

            if (documentnotuploads == true) {
                fetchUploadFiles()
            }

            else {
                const payload = {
                    data: {
                        ticket_assign_mode: state.StateManagementOverallCall.AssignandReassign == 1 ? "assign" : "reassign",
                        remarks: data.remarks,
                        priority: data.priority,
                        client_subcategory: true,
                        internal_category_id: data.internal_category_id,
                        department_id: data.department_id,
                        documents: [],
                    },
                    EditId: state.StateManagementOverallCall.AssignandReassign == 1 ? state.StateManagementOverallCall.TicketIDS : state.StateManagementOverallCall.ReassignTicketIds,
                    ticket_assign_mode: state.StateManagementOverallCall.AssignandReassign == 1 ? "Assign" : "Reassign",

                    Funcations: () => {
                        if (state.StateManagementOverallCall.AssignandReassign == 1) {
                            //     if(state.NeededdatasListed.findthReassings == 3){ 
                            // Navigate("/ticketviews")
                            //     }
                            //     else{
                            //         Navigate("/ticketviews")

                            //     }

                            Navigate("/ticketviews")


                        }
                        else {
                            // Navigate("/internal_ticketview")
                            // Navigate("/internalTicketuserlist")      

                            // if (state.NeededdatasListed.findthReassings == 3) {
                            //     Navigate("/sub_ticker")
                            // }
                            // else {
                            //     // Navigate("/internalTicketuserlist")
                            //     Navigate("/sub_ticker")

                            // }



                            if (state.NeededdatasListed.findthReassings == 3) {
                                Navigate("/sub_ticker")
                            }
                            else if (state.NeededdatasListed.findthReassings == 9) {
                                // Navigate("/internal_ticketview")
                                Navigate("/ticketdashboard")
                            }
                            else {
                                Navigate("/sub_ticker")
                            }

                        }
                    },
                    //   Funcationsreassign: () => {
                    //     Navigate("/internal_ticketview")

                    //   },

                }
                dispatch(setthereassignandAssignRejectDataActions(payload))
            }
        }
        else {
            toast.info("Please Fill the Mandatory Fields");

        }
    }

    console.log(state.NeededdatasListed.findthReassings, "NeededdatasListed.findthReassings");

    return (
        <>

            <div className="RoleCreatePopup" style={{ background: "#ffffffb5" }}>
                <div className="BeforePopUp">
                    <div className="RolePopups" style={{
                        width: "72%", borderRadius: "17px",
                        boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}>
                        <div className="asd ticketRaisePopups">

                            <div className='row ticketrasiseofViews'>
                                <div className='col-5 leftsidetParted'>
                                    <div className="Popupcreatetickets">
                                        <h3>
                                            {state.StateManagementOverallCall.AssignandReassign == 1 ?
                                                "Sub Assign  " :
                                                "Reassign  "} Ticket
                                        </h3>

                                        <div className="InnerImages">
                                            <img src={TicketCreation} alt="" />
                                        </div>
                                    </div>
                                    <div className="CreatedBy">
                                        <div className="CreateBodyofcontent" style={{ gap: "12px" }}>
                                            <div className="createrimgs">
                                                <img src={Userim} alt="" />
                                            </div>
                                            <div className="CreatedByNames">
                                                <p>

                                                    {state.StateManagementOverallCall.AssignandReassign == 1 ?
                                                        "Sub Assign " :
                                                        "Reassign "}

                                                    by {capitalizeFirstLetter(state.SideBarFiles.Role.toLowerCase())}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-7 rightsideTicketCreated'>

                                    <div className='Closeofpopupse' >
                                        <img src={CloseIcons} alt="" onClick={(e) => {
                                            dispatch(settheTicketSuccesspopuos(false))

                                            if (state.StateManagementOverallCall.AssignandReassign == 1) {
                                                // window.location.href="/ticketlist"
                                                Navigate("/ticketviews");

                                            }
                                            else if (state.StateManagementOverallCall.AssignandReassign == 2) {
                                                //  window.location.href="/internalTicketuserlist"
                                                // Navigate("/internal_ticketview");
                                                Navigate("/sub_ticket_internal_view")

                                            }

                                        }} />

                                    </div>

                                    <>

                                        <div className="col-12 mb-3 d-flex">

                                            <div className="col-6 mb-1 field-div">
                                                <label
                                                    for="validationCustom01"
                                                    class="form-label"
                                                >
                                                    Department
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <Select
                                                    value={departmentValue}
                                                    options={departmentoptions}

                                                    onChange={(e) => {
                                                        HandletheDepartmentvalues(e)
                                                    }}
                                                    onInputChange={(e) => { handleInputDepartment(e) }}
                                                />

                                            </div>


                                            <div className="col-6 mb-1 field-div">
                                                <label
                                                    for="validationCustom01"
                                                    class="form-label"
                                                >
                                                    Category
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <Select
                                                    value={categoryvaluese}
                                                    options={categoryption}

                                                    onChange={(e) => {
                                                        HandletheCatgoryListed(e)
                                                    }}
                                                    onInputChange={(e) => { handleInputcategorySearc(e) }}
                                                />

                                            </div>


                                        </div>

                                        <div className="col-12 mb-3 d-flex">

                                            <div className="col-6 mb-1 field-div">
                                                <label
                                                    for="validationCustom01"
                                                    class="form-label"
                                                >
                                                    Subcategory
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <Select
                                                    value={categoryvalue}
                                                    options={Categorydata}

                                                    onChange={(e) => {
                                                        HandleCategoryMuliti(e)
                                                    }}
                                                    onInputChange={(e) => { handleInputcategory(e) }}
                                                />

                                            </div>
                                            <div className="col-6 mb-1 field-div">
                                                <label
                                                    for="validationCustom01"
                                                    class="form-label"
                                                >
                                                    Priority
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <Select
                                                    value={Priorityvalues}
                                                    options={priorityoptions}

                                                    onChange={(e) => {
                                                        handletheprioritychanges(e)
                                                    }}
                                                />

                                            </div>

                                        </div>


                                        <div className="col-12 mb-3 d-flex">

                                            <div className="col-12 mb-1 field-div">
                                                <label
                                                    for="validationCustom01"
                                                    class="form-label"
                                                >
                                                    Description
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <textarea className="form-control"

                                                    onChange={(e) => {
                                                        const inputValue = e.target.value;

                                                        setData({
                                                            ...data,
                                                            remarks:
                                                                inputValue.charAt(0).toUpperCase() +
                                                                inputValue.slice(1),
                                                        });
                                                    }}
                                                    value={data.remarks}

                                                />

                                            </div>

                                        </div>


                                        <div className="col-12 mb-5 DocumentsUpload">
                                            <div className="col-12 mb-1 field-div">
                                                <label className="form-label LabelRemove">
                                                    Attachments Upload
                                                </label>
                                                <div
                                                    className="form-control InnerControls"
                                                    onDrop={handleDrop}
                                                    onDragOver={handleDragOver}
                                                    onDragEnter={handleDragEnter}
                                                    onDragLeave={handleDragLeave}
                                                    style={{
                                                        borderRadius: "10px",
                                                        textAlign: "center",
                                                        backgroundColor: isDragging
                                                            ? "hsla(203, 49%, 81%, 0.25)"
                                                            : "transparent", // Change background color
                                                        transition: "background-color 0.3s ease", // Smooth transition
                                                    }}
                                                >
                                                    <div className="d-flex flex-wrap align-items-center gap-3">
                                                        {
                                                            PresentUrls.map((file, index) => {
                                                                let displayImg
                                                                //   if (
                                                                //     file.type === "image/png" ||
                                                                //     file.type === "image/jpeg"
                                                                //   ) {
                                                                //     displayImg = Attachment; // Replace with your gallery image variable
                                                                //   } else if (file.type === "application/pdf") {
                                                                //     displayImg = Attachment; // Replace with your PDF icon variable
                                                                //   } else if (
                                                                //     file.type === "application/vnd.ms-excel" ||
                                                                //     file.type ===
                                                                //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                                //   ) {
                                                                //     displayImg = Attachment; // Replace with your Excel icon variable
                                                                //   } else {
                                                                //     displayImg = Attachment; // Replace with a default image/icon if none match
                                                                //   }

                                                                if (file.type === "image/png" || file.type === "image/jpeg") {
                                                                    displayImg = galleyimg; // Replace with your gallery image variable
                                                                } else if (file.type === "application/pdf") {
                                                                    displayImg = PDFIMAGE; // Replace with your PDF icon variable
                                                                } else if (file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                                                                    displayImg = excelimg; // Replace with your Excel icon variable
                                                                } else {
                                                                    displayImg = gallimages; // Replace with a default image/icon if none match
                                                                }


                                                                return (
                                                                    <>
                                                                        <div
                                                                            key={index}
                                                                            style={{
                                                                                position: "relative",
                                                                                width: "38px",
                                                                                height: "38px",
                                                                                borderRadius: "8px",
                                                                            }}
                                                                        >

                                                                            <img
                                                                                src={displayImg}
                                                                                alt={`Uploaded File ${index + 1}`}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                    objectFit: "cover",
                                                                                    borderRadius: "8px",
                                                                                    border: "1px solid #ddd",
                                                                                }}
                                                                            />
                                                                            <span
                                                                                style={{
                                                                                    fontSize: "12px",
                                                                                    textTransform: "capitalize",
                                                                                }}
                                                                            >
                                                                                {file?.putfiles?.name?.length > 5
                                                                                    ? `${file?.putfiles.name.slice(
                                                                                        0,
                                                                                        5
                                                                                    )}...`
                                                                                    : file?.putfiles?.name}
                                                                            </span>
                                                                            <button
                                                                                type="button"
                                                                                className=" btn-danger btn-sm DeleteImages"
                                                                                onClick={() => removeFile(index)}
                                                                            >
                                                                                &times;
                                                                            </button>
                                                                        </div>
                                                                    </>
                                                                );
                                                            })
                                                        }

                                                        {uploadedFiles.length == 0 && (
                                                            <div className="InnerImages InnerImgGallery d-flex flex-wrap align-items-center  justify-content-center">
                                                                <img src={galleryImg} />
                                                            </div>
                                                        )}
                                                    </div>

                                                    <p className="">
                                                        Drag your files and here to Upload
                                                        <label
                                                            className="Droplabel Droplabel2"
                                                            htmlFor="fileUploadInput"
                                                        >
                                                            Browse file
                                                        </label>

                                                        <input
                                                            id="fileUploadInput"
                                                            type="file"
                                                            style={{ display: "none" }} // Hidden input
                                                            onChange={handleFileChange} // Handles file selection
                                                            multiple // Allows multiple file selection
                                                        />

                                                    </p>
                                                    <span>Maximum file size 25 MB </span>

                                                </div>
                                            </div>
                                        </div>
                                    </>

                                    <div className="RoleButton"
                                        style={{
                                            display: "flex",
                                            gap: "15px",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            padding: "0px  29px"
                                        }}

                                    >
                                        <button
                                            class="btn  Createbutton"
                                            type="submit"
                                            onClick={(e) => {
                                                HandleClick(e);
                                            }}
                                        >
                                            {state.StateManagementOverallCall.AssignandReassign == 1 ?
                                                "Sub Assign   " :
                                                "Reassign  "}
                                            Ticket
                                        </button>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {state.NeededdatasListed.ticketReassignpopup && (
                <>
                    <div className="CommentPopup">
                        <div className="innercommentpopup">
                            <div className="FormPartsthanks FormPartsticketslist FormPartsticketsCreated">
                                <div className="innerformscomentpart">
                                    <div className="Notifyimgsthumbs">
                                        <img src={thumbsup} />
                                    </div>
                                    <div className="closecontent CloseIcons">
                                        <img
                                            src={closepopup}
                                            alt=""
                                            onClick={(e) => {
                                                dispatch(settheReassignTicketpopups(false))
                                                // Navigate("/sub_ticker")
                                                if (state.NeededdatasListed.findthReassings == 3) {
                                                    Navigate("/sub_ticker")
                                                }
                                                else if (state.NeededdatasListed.findthReassings == 9) {
                                                    // Navigate("/internal_ticketview")
                                                    Navigate("/ticketdashboard")
                                                }
                                                else {
                                                    Navigate("/sub_ticker")
                                                }
                                                // Navigate("/internalTicketuserlist")

                                            }}
                                        />
                                    </div>

                                    <div className="ticketnumberlist">
                                        <span className="InnerNUmber">
                                            <img src={ticketimg} />
                                            <span>
                                                {"ID  "}
                                                {state.TicketReassignAssignRejectCalls?.InternalAssignReassignReject?.ticket_number}
                                            </span>
                                        </span>
                                    </div>
                                    <h5 className="pt-4">Successfully Internal Ticket Reassigned !</h5>


                                    <div className="feedbacksubmition">
                                        <button
                                            onClick={(e) => {
                                                setthankcontent(false);
                                                // dispatch(settheReassignTicketpopups(false))
                                                // // dispatch(settheTicketViewIds(state.CreateinternalTicketListed.CreateInternalTicketListeds.id))

                                                // // settheThankpopup(false);
                                                // // settheTicketIDs(TicketCreateREsponse?.id);
                                                // Navigate("/sub_ticker")
                                                // Navigate("/internalTicketuserlist");


                                                dispatch(settheReassignTicketpopups(false))
                                                // Navigate("/sub_ticker")
                                                if (state.NeededdatasListed.findthReassings == 3) {
                                                    Navigate("/sub_ticker")
                                                }
                                                else if (state.NeededdatasListed.findthReassings == 9) {
                                                    // Navigate("/internal_ticketview")
                                                    Navigate("/ticketdashboard")
                                                }
                                                else {
                                                    Navigate("/sub_ticker")
                                                }

                                            }}
                                        >
                                            ok
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

        </>
    )
}

export default TicketAssigns


